interface SparklineProps {
  data: number[];
  color?: string;
  className?: string;
}

import { usePrimaryColor } from "../../branding/usePrimaryColor";

export function Sparkline({ data, color, className = "" }: SparklineProps) {
  const primaryColor = usePrimaryColor();
  const effectiveColor = color ?? primaryColor;

  if (!data.length) return null;

  const max = Math.max(...data);
  const min = Math.min(...data);
  const range = max - min || 1;

  const pathData = data
    .map((value, index) => {
      const x = (index / (data.length - 1)) * 100;
      const y = 28 - ((value - min) / range) * 24; // 4px padding top/bottom
      return `${index === 0 ? "M" : "L"} ${x} ${y}`;
    })
    .join(" ");

  return (
    <div className={`spark-bg h-7 rounded-sm ${className}`}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 100 28"
        preserveAspectRatio="none"
        className="w-full h-full"
      >
        <path
          d={pathData}
          stroke={effectiveColor}
          strokeWidth="1.5"
          fill="none"
          vectorEffect="non-scaling-stroke"
        />
      </svg>
    </div>
  );
}
